<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-25 15:17:30
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-16 10:51:16
-->
<template>
	<el-tooltip class="inlineBlock" :placement="placement">
		<p slot="content" class="pre content" :style="{ width: width + 'px' }">{{ content }}</p>
		<span :class="['flex flex-align-center', classStyle]" style="width: fit-content">
			<slot></slot>
			<i class="iconfont" :class="[icon, `fz-${size}`]" v-if="showIcon"></i>
		</span>
	</el-tooltip>
</template>
<script>
export default {
	props: {
		content: {
			type: String,
			default: '',
		},
		placement: {
			type: String,
			default: 'top',
		},
		classStyle: {
			type: String,
			default: '',
		},
		width: {
			type: [Number, String],
			default: 200,
		},
		showIcon: {
			type: Boolean,
			default: true,
		},
		icon: {
			type: String,
			default: 'iconfont icon-a-help-circle-obangzhu-xian',
		},
		size: {
			type: [Number, String],
			default: 14,
		},
	},
};
</script>
<style lang="less" scoped>
.inlineBlock {
	display: inline-block;
}
.icon-a-help-circlebangzhu-mian {
	color: @color-gy6;
	font-size: 12px;
}
</style>
